import { Button } from "@/components/ui/button";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { cn } from "@/lib/utils";
import type { ComponentProps } from "react";

export type SuggestionsProps = ComponentProps<typeof ScrollArea>;

export function Suggestions({
  className,
  children,
  ...props
}: SuggestionsProps) {
  return (
    <ScrollArea
      className="overflow-x-auto w-full whitespace-nowrap"
      data-slot="suggestions"
      {...props}
    >
      <div className={cn("flex flex-nowrap gap-2 items-center w-max", className)}>
        {children}
      </div>
      <ScrollBar className="hidden" orientation="horizontal" />
    </ScrollArea>
  );
}

export type SuggestionProps = Omit<ComponentProps<typeof Button>, "onClick"> & {
  suggestion: string;
  onClick?: (suggestion: string) => void;
};

export function Suggestion({
  suggestion,
  onClick,
  className,
  variant = "outline",
  size = "sm",
  children,
  ...props
}: SuggestionProps) {
  const handleClick = () => {
    onClick?.(suggestion);
  };

  return (
    <Button
      className={cn("px-4 rounded-full cursor-pointer", className)}
      data-slot="suggestion"
      onClick={handleClick}
      size={size}
      type="button"
      variant={variant}
      {...props}
    >
      {children || suggestion}
    </Button>
  );
}
